export const PRODUCTS_ACTIONS = {
  INITIALIZE_PRODUCTS: "INITIALIZE_PRODUCTS",
  SHOW_LOADER: "SHOW_LOADER",
};
